import "core-js/modules/es.array.push.js";
import Pagination from '@/components/Pagination.vue';
import { useRouter } from 'vue-router';
import { defineComponent, getCurrentInstance, toRefs, reactive, onActivated } from 'vue';
import { useStore } from '@/store/index';
import Keys from '@/constant/key';
import { Status } from './enum';
import { OCheckStatus, ProductO } from '@/enums/product';
import { joinParams } from '@/utils/index';
import SelectBrand from '@/components/SelectBrand.vue';
import { UserMutationTypes } from '@/store/modules/user/mutation-types';
import { offTypes } from './enum';
import { updateSpecStatusAPi } from '@/apis/product';
export default defineComponent({
  name: 'ProductList',
  components: {
    SelectBrand,
    Pagination
  },
  setup() {
    const {
      proxy
    } = getCurrentInstance();
    const router = useRouter();
    const store = useStore();
    const state = reactive({
      filters: {
        brand_id: '',
        second_brand_name: '',
        title: '',
        status: null,
        admin_name: '',
        check_start_date: '',
        check_end_date: '',
        start_date: '',
        end_date: '',
        is_new: 0,
        //product_status:     '',     //商品上下架状态
        page: 1,
        page_size: 10,
        is_yy_check: 1
      },
      ids: '',
      check_msg: '',
      shelf: {
        soldout_type: '',
        soldout_reson: ''
      },
      productShelfShow: false,
      rejectDialog: false,
      checkStatusDisabled: false,
      total: 0,
      tableData: [],
      brandList: [],
      groupList: store.state.user.userInfo.group_id,
      productSubmissionShow: false,
      productSubmissioData: [],
      //审核过的不可选中
      selectable: row => {
        if (row.status != 1) {
          return false;
        } else {
          return true;
        }
      },
      // 选中监听
      onSelectionChange: val => {
        state.ids = val.filter(item => item.status == 1).map(item => item.id).join(',');
      },
      //批量通过驳回
      /**
       * 运营审核：1-通过并上架，2-通过并下架，3-驳回
      */
      toCheck: check_type => {
        const {
          check_msg,
          shelf,
          ids
        } = state;
        const {
          soldout_type,
          soldout_reson
        } = shelf;
        if (ids == '') {
          return proxy.$message({
            type: 'error',
            message: '请先选择商品'
          });
        }
        // 填写驳回原因
        if (check_type === 3 && !check_msg) {
          return proxy.$message({
            type: 'error',
            message: '请输入驳回原因'
          });
        }
        //运营下架填写原因
        if (check_type === 2 && !soldout_type) {
          proxy.$message({
            type: 'error',
            message: '请选择下架类型'
          });
          return;
        }
        proxy.$http.post('/cake_api/operation_check_all', {
          save_ids: ids,
          soldout_type,
          soldout_reson,
          check_msg,
          check_type
        }).then(res => {
          const {
            code,
            data,
            msg
          } = res;
          if (code != 200) {
            return proxy.$message({
              type: 'error',
              message: msg
            });
          }
          state.getList();
          store.commit(UserMutationTypes.MINUS_MENU_WARNING_ITEM, 'unCheckProduct'); // 菜单提醒数字减一
          state.productShelfShow = false; // 关闭下架类型弹框
          state.onRejectDialogClose(); // 清空驳回弹框内容
        });
      },
      // 驳回弹框关闭前清空数据
      onRejectDialogClose: () => {
        state.check_msg = '';
        state.rejectDialog = false;
      },
      //打开下架原因弹窗
      openDialog() {
        state.shelf.soldout_type = '';
        state.shelf.soldout_reson = '';
        state.productShelfShow = true;
      },
      //取消下架
      onProductShelfShow() {
        state.shelf.soldout_type = '';
        state.shelf.soldout_reson = '';
        state.productShelfShow = false;
        nextTick(() => {
          proxy.$refs['shelfProductForm'].clearValidate();
        });
      },
      // 获取表格数据
      getList: () => {
        proxy.$http.get('/cake_api/operation_check_list', state.filters).then(res => {
          if (res.code == 200) {
            state.tableData = res.data.data || [];
            state.tableData = Object.assign(state.tableData, {
              showAll: 0
            });
            state.total = res.data.total;
            sessionStorage.setItem('productString', res.data.product_ids);
            let product = sessionStorage.getItem('productString');
          } else {
            state.tableData = [];
          }
        });
      },
      onBrandChange: val => {
        state.filters.brand_id = val;
      },
      toggleShowAll(row) {
        row.showAll = !row.showAll;
      },
      // 跳转至编辑页
      toEdit: (row, t) => {
        router.push(`/check/product-edit?id=${row.id}&t=${t}&o=${ProductO['审核列表']}`);
      },
      toCustomer: row => {
        const id = {
          id: row.id
        };
        proxy.$confirm('确定转至客服审核吗？', '提示', {
          type: 'warning'
        }).then(() => {
          proxy.$http.post('/cake_api/operation_check_transfer', id).then(res => {
            const {
              code,
              data,
              msg
            } = res;
            if (code != 200) {
              return proxy.$message({
                type: 'error',
                message: msg
              });
            }
            proxy.$message({
              type: 'success',
              message: '操作成功'
            });
            state.getList();
          });
        }).catch(() => {
          console.log('取消转移订单');
        });
      },
      toProduct: row => {
        state.productSubmissionShow = true;
        state.productSubmissioData = row.jingjia_info;
      },
      onproductSubmissionShow() {
        state.productSubmissionShow = false;
      },
      // 搜索
      onSearch: () => {
        state.filters.page = 1;
        state.getList();
      },
      // 规格导出
      onExport: () => {
        window.open(`${Keys.baseUrl}/cake_api/operation_check_list?${joinParams({
          ...state.filters,
          user_id: store.state.user.userInfo.id,
          type: 2
        })}`);
      },
      // 商品导出
      onProductExport: () => {
        window.open(`${Keys.baseUrl}/cake_api/operation_check_list?${joinParams({
          ...state.filters,
          user_id: store.state.user.userInfo.id,
          type: 3
        })}`);
      },
      // 换页
      // onPageChange: (val) => {
      //     state.filters.page = val
      //     state.getList()
      // }
      // 新商品选中监听，当状态为选中状态时，将审核状态置为待审核状态（仅支付查找待审核状态的新商品）
      isNewChange: function () {
        if (state.filters.is_new) {
          state.filters.status = 1;
          state.checkStatusDisabled = true;
        } else {
          state.checkStatusDisabled = false;
        }
      },
      onPageChange: val => {
        state.filters.page = val;
        state.getList();
      },
      onSizeChange: val => {
        state.filters.page_size = val;
        state.getList();
      },
      updateSpecStatus: row => {
        const {
          spec_id,
          name,
          deleted
        } = row;
        proxy.$confirm(`确定要下架${name}规格 吗？`, '提示', {
          type: 'warning'
        }).then(() => {
          let is_admin = 1;
          let specs_id = spec_id;
          updateSpecStatusAPi(specs_id, is_admin).then(res => {
            const {
              code,
              data,
              msg
            } = res;
            if (code != 200) {
              return proxy.$message({
                type: 'error',
                message: msg
              });
            }
            proxy.$message({
              type: 'success',
              message: '操作成功'
            });
            row.deleted = deleted ^ 1;
          });
        }).catch(() => {
          console.log('取消规格上下架操作');
        });
      }
    });
    state.getList();
    onActivated(() => {
      state.getList();
    });
    return {
      ...toRefs(state),
      Keys,
      store,
      OCheckStatus,
      Status,
      offTypes
    };
  }
});